import type { AptiRequestConfig } from "@/lib/types/api";
import { getGroupAuthType } from "@/redux/actions/auth";
import { GROUP_AUTH_HEADER_NAME } from "@/constants/axios";
import type { PatientConsent, PatientStatus, UUID } from "@/core/types";

import { httpAuth } from "../utils/axios";

type UpdatePatientStatusPayload = {
  providerName?: string;
  reason?: string;
  status: PatientStatus;
  username: UUID;
};

export type UpdatePatientStatusResponse = {
  previous_status: PatientStatus;
};

export const providerRequestsTyped = {
  get_patient_consents: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: UUID;
  }) {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/patient_management/${patientId}/get_latest_consents`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<PatientConsent[]>;
  },

  update_patient_status: function ({
    data,
    patientId,
  }: {
    data: UpdatePatientStatusPayload;
    patientId: UUID;
  }) {
    const config = {
      data,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      url: `/v1/patient_management/${patientId}/update_patient_details`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<UpdatePatientStatusResponse>;
  },
};
